<template>
	<div class="trun-role">
		<div class="page-handle">
			<div class="left">
				<a-button type="primary" @click="addRow()">添加分子分型</a-button>
			</div>
			<div class="right">
				<a-cascader
						:options="options"
						placeholder="请选择父级简称"
						change-on-select
						@change="onChange"
				/>
				<a-input-search @search="onSearch" placeholder="请输入简称/全称" style="width: 200px; margin-left: 15px;"/>
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					:pagination="false"
					:columns="columns"
					:dataSource="dataRow.records"
					:rowKey="record => record.id"
					:loading="loading"
					class="hospital-table"
					size="middle"
			>
				<span slot="number" slot-scope="text,record,index">{{(page-1)*pageSize+index+1}}</span>
				<template slot="layer" slot-scope="text,record,index">
					<span>{{findLayerText(record)}}</span>
				</template>
				<template slot="opt" slot-scope="text,record,index">
					<a href="javascript:;" @click="eidtRow(text,record,index)" class="cf-mr10">编辑</a>
					<a href="javascript:;" @click="delRow(text,record,index)" class="cf-mr10">删除</a>
				</template>
			</a-table>
		</div>
		<div class="pagination">
			<a-pagination
					@change="pageChange"
					:pageSize.sync="pageSize"
					v-model="page"
					size="small"
					:total="dataRow.total"
			/>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<molecular-typing-add
					v-if="visible"
					@close="closeModel"
					:editDataRow="selectData"
					:editMtId="mtId"
					:layerSelectOption="layerSelectOption"
			></molecular-typing-add>
		</page-model>
		<h-confirm
				:visible="confirmVisible"
				@close="closeConfirm"
				@ok="okClick"
				:loadding.sync="confirmLoadding"
				:title="currentConfirmData.title"
				:content="currentConfirmData.content"
				:desc="currentConfirmData.desc"
		></h-confirm>
	</div>
</template>

<script>
  import {regAll, checkNameR} from "../../common/validate";
  import MolecularTypingAdd from "./molecularTypingAdd";

  const columns = [
    {
      title: "序号",
      scopedSlots: {customRender: "number"}
    },
    {
      title: "简称",
      dataIndex: "abbrev",
      width: '35%'
    },
    {
      title: "全称",
      dataIndex: "fullName"
    },
    {
      title: "父级简称",
      dataIndex: "parentName",
      scopedSlots: {customRender: "parentName"},
      width: '15%'
    },
    {
      title: "操作",
      scopedSlots: {customRender: "opt"},
      width: '15%'
    }
  ];
  export default {
    data() {
      return {
        columns,
        dataRow: [],
        options: [],
        selectData: {},
        parentId: '',
        search: '',
        page: 1,
        pageSize: 10,
        mtId: '',
        count: 2,
        isSubmit: false,
        loading: false,
        visible: false,
        confirmLoadding: false,
        confirmVisible: false,
        layerSelectOption: [{key: 1, textVal: '一级'}, {key: 2, textVal: '二级'}, {key: 3, textVal: '三级'}, {
          key: 4,
          textVal: '四级'
        }],
        currentConfirmData: {
          title: "删除",
          content: "您确认删除这条数据么？",
          desc: ""
        }
      };
    },
    components: {MolecularTypingAdd},
    mounted() {
      this.getMtList();
      this.getLayerLst(-1);
    },
    methods: {
      getLayerLst(id) {
        this.$get('mt/q/mtt').then(res => {
          if (res.data.code == 1) {
            this.options = [{value: -1, label: '顶级', children: res.data.data}];
          }
        })
      },
      findLayerText(record) {
        let result = '-';
        if (record) {
          this.layerSelectOption.forEach((item, index) => {
            if (item.key == record.layer) {
              result = item.textVal;
              return;
            }
          })
        }
        return result;
      },
      getMtList() {
        this.loading = true;
        this.$post("mt/query", {
          parentId: this.parentId,
          search: this.search,
          pageNum: this.page,
          pageSize: this.pageSize,
        }, {
          "Content-Type": "application/json"
        }).then(res => {
          this.dataRow = res.data.data;
          this.loading = false;
        });
      },
      eidtRow(text, record, index) {
        this.selectData = record;
        this.mtId = record.id;
        this.visible = true;
      },
      onChange(value) {
        if (value) {
          this.parentId = value[value.length - 1]
        }
        this.page = 1;
        this.getMtList();
      },
      onSearch(value) {
        this.search = value;
        this.page = 1;
        this.getMtList();
      },
      pageChange(page, pagesize) {
        this.page = page;
        this.pageSize = pagesize;
        this.getMtList();
      },
      delRow(text, record, index) {
        this.confirmVisible = true;
        this.selectData = record;
      },
      addRow() {
        this.selectData = {};
        this.mtId = '';
        this.visible = true;
      },
      okClick() {
        this.$post("mt/del/" + this.selectData.id, {}, {
          "Content-Type": "application/json"
        }).then(
          res => {
            if (res.data && res.data.code == 1) {
              this.confirmVisible = false;
              this.confirmLoadding = false;
              this.$message.success("删除数据成功");
              this.getMtList();
            } else {
              this.confirmLoadding = false;
              this.$message.error(res.data.message);
            }
          },
          err => {
            this.confirmLoadding = false;
            this.$message.error("删除数据失败");
          }
        );
      },
      closeModel() {
        this.visible = false;
        this.getMtList();
      },
      closeConfirm() {
        this.confirmVisible = false;
      },
    }
  };
</script>

<style lang="scss" scoped>
	.trun-role {
		.pagination {
			padding: 0 30px;
		}
	}
</style>